<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="options"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      :placeholder="placeholder"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="loading"
          :style="{ opacity: loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay unidades para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapGetters } from 'vuex';

import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';

export default {
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'companyId'
    ]),
    optionSelected() {
      return this.options.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled || !this.options.length || this.loading;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.options.find((option) => option.value === this.value);
    },
    async fetch({ divisionId } = {}) {
      const routeName = this.$route.name;
      this.loading = true;
      const { data: { grupos: options } } = await ioCompanyGroups(
        {
          empresaId: this.companyId,
          filtros: divisionId ? `divisionId:${divisionId}` : ''
        }
      );
      this.options = options
        .map((option) => ({
          id: option.id,
          value: option.id,
          label: option.nombre
        }))
        .sort(({ label: a }, { label: b }) => a.localeCompare(b));
      if (routeName === 'approval-dashboard') {
        this.options.unshift({ id: '*', value: '*', label: 'Todas las unidades' });
      }
      this.loading = false;
    }
  },
  created() {
    this.$watch('parentValue', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        if (oldValue !== '') {
          this.$emit('input', '');
        }
        this.fetch({ divisionId: newValue });
      }
    });

    if (this.parentValue) {
      this.fetch({ divisionId: this.parentValue });
    } else {
      this.fetch();
    }
  },
  props: {
    name: { type: String, required: true },
    placeholder: String,
    autocomplete: { type: Boolean, default: false },
    label: { type: String, default: 'Unidades' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    parentValue: String,
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  }
};

</script>
